export const isDevEnv = () => {
  const devEnvs = ["localhost", "dev", "mars", "orion", "tde", "tae", ".pre."];
  return devEnvs.some((match) => window.location.href.toLowerCase().includes(match));
};

export const isLocalEnv = window.location.hostname === "localhost";
export const isAutomationEnv = window.location.href.toLowerCase().includes("tae-");
const ENVIRONMENT_URL_PARTS = {
  local: ["local", "localhost"],
  dev: ["dev", "mars", "orion", "tae", "tde"],
  staging: ["pre", "staging"],
  sandbox: ["sandbox"],
  demo: ["demo"],
  prod: []
};

// Priority matters
const ENV_PRIORITY = ["local", "dev", "staging", "sandbox", "demo"];

const extractUrlParts = (hostname) => {
  return Array.from(
    new Set(
      hostname
        .toLowerCase()
        .split(/[./]+/)
        .flatMap((part) => [part, ...part.split(/[-_]/)])
    )
  );
};

/**
 * Get environment type from hostname
 */
export const getEnvironmentType = (envString) => {
  const hostname = envString || (typeof window !== "undefined" ? window.location.hostname : "");

  const urlParts = extractUrlParts(hostname);

  const matchedEnv = ENV_PRIORITY.find((env) => ENVIRONMENT_URL_PARTS[env].some((part) => urlParts.includes(part)));

  return matchedEnv || "prod";
};
